import React from 'react';
import type { Accept } from 'react-dropzone';
import ImportFileModal from './ImportFileModal';
import { ImportSource } from '../../graphql/generated/graphql';
import Link from '../../utils/router/Link';

interface NotionImportModalProps {
  accept?: Accept;
  close: () => void;
}

const NotionImportModal = (props: NotionImportModalProps) => (
  <ImportFileModal
    {...props}
    source={ImportSource.Notion}
    uploaderSubject="the zip file from Notion's HTML export"
    footer={
      <Link
        to="https://go.slab.com/importing-all-your-content-from-notion"
        newTab
      >
        How do I export from Notion?
      </Link>
    }
  />
);

export default NotionImportModal;
